var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8524 12.6225L14.1449 14.9925C14.2199 15.615 13.5524 16.05 13.0199 15.7275L9.87738 13.86C9.53238 13.86 9.19489 13.8375 8.86489 13.7925C9.41989 13.14 9.74989 12.315 9.74989 11.4225C9.74989 9.29249 7.90489 7.56752 5.62489 7.56752C4.75489 7.56752 3.95239 7.815 3.28489 8.25C3.26239 8.0625 3.25488 7.87499 3.25488 7.67999C3.25488 4.26749 6.21738 1.5 9.87738 1.5C13.5374 1.5 16.4999 4.26749 16.4999 7.67999C16.4999 9.70499 15.4574 11.4975 13.8524 12.6225Z",
    stroke: "#66676F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.4226C9.75 12.3151 9.42001 13.1401 8.86501 13.7926C8.12251 14.6926 6.945 15.2701 5.625 15.2701L3.6675 16.4326C3.3375 16.6351 2.9175 16.3576 2.9625 15.9751L3.15 14.4976C2.145 13.8001 1.5 12.6826 1.5 11.4226C1.5 10.1026 2.205 8.94011 3.285 8.25011C3.9525 7.81511 4.755 7.56763 5.625 7.56763C7.905 7.56763 9.75 9.29259 9.75 11.4226Z",
    stroke: "#66676F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIcon);
export default __webpack_public_path__ + "static/media/messages-icon.2a188b8bc69952350072de9ca3728a53.svg";
export { ForwardRef as ReactComponent };